import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const fadeIn = useFadeIn();
  const packs = [{
    emoji: '💜',
    title: 'Mamá e Hija',
    subtitle: '100 Citas especiales',
    desc: 'Actividades, conversaciones y momentos únicos para fortalecer el vínculo más especial entre mamá e hija. Incluye sección para fotos y recuerdos 📸',
    color: 'border-purple-300 bg-purple-50',
    accent: 'text-purple-600'
  }, {
    emoji: '💙',
    title: 'Mamá e Hijo',
    subtitle: '100 Citas especiales',
    desc: 'Ideas y experiencias diseñadas para conectar de verdad entre mamá e hijo. Incluye sección para fotos y recuerdos 📸',
    color: 'border-blue-300 bg-blue-50',
    accent: 'text-blue-600'
  }, {
    emoji: '💖',
    title: 'Papá e Hija',
    subtitle: '100 Citas especiales',
    desc: 'Momentos pensados para crear recuerdos inolvidables entre papá e hija. Incluye sección para fotos y recuerdos 📸',
    color: 'border-pink-300 bg-pink-50',
    accent: 'text-pink-600'
  }, {
    emoji: '💚',
    title: 'Papá e Hijo',
    subtitle: '100 Citas especiales',
    desc: 'Aventuras, charlas y actividades para fortalecer la complicidad entre papá e hijo. Incluye sección para fotos y recuerdos 📸',
    color: 'border-green-300 bg-green-50',
    accent: 'text-green-600'
  }];
  return <section className="py-10 md:py-16 px-4 bg-gray-50" data-id="element-266">
      <div className="max-w-3xl mx-auto" data-id="element-267">
        <div ref={fadeIn.ref} className={`text-center ${fadeIn.className}`} data-id="element-268">
          <h2 className="text-2xl md:text-5xl font-black text-gray-900 mb-8 md:mb-10" data-id="element-269">
            📚 Lo que incluye el Pack
          </h2>

          <div className="space-y-4 md:space-y-6 mb-8 md:mb-12" data-id="element-270">
            {packs.map((pack, i) => <div key={i} className={`${pack.color} border-2 rounded-2xl p-5 md:p-8 text-left shadow-sm`} data-id="element-271">
                <div className="flex items-start gap-4" data-id="element-272">
                  <span className="text-3xl md:text-4xl flex-shrink-0" data-id="element-273">
                    {pack.emoji}
                  </span>
                  <div data-id="element-274">
                    <h3 className={`text-xl md:text-2xl font-black ${pack.accent} mb-1`} data-id="element-275">
                      {pack.title}
                    </h3>
                    <p className="text-base md:text-lg font-bold text-gray-900 mb-2" data-id="element-276">
                      {pack.subtitle}
                    </p>
                    <p className="text-sm md:text-lg text-gray-600 font-medium" data-id="element-277">
                      {pack.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="max-w-md mx-auto" data-id="element-278">
            <CTAButton text="👉 QUIERO MI PACK AHORA" data-id="element-279" />
          </div>
        </div>
      </div>
    </section>;
}